import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" {...props}><path d="M11 6H9V2h2v4zm2-3V1a1 1 0 00-1-1H8a1 1 0 00-1 1v2H0v2h7v2a1 1 0 001 1h4a1 1 0 001-1V5h7V3h-7zM16 16h-2v-4h2v4zm2-5a1 1 0 00-1-1h-4a1 1 0 00-1 1v2H0v2h12v2a1 1 0 001 1h4a1 1 0 001-1v-2h2v-2h-2v-2z" /></svg>;